export default __webpack_public_path__ + "static/20250425-4c29304cca0d5f3d540e0a5f42693b6e.png";